"use client"

import styled from "styled-components"
import {
  Badge,
  BigValue,
  Card,
  CardHeader,
  List,
  MonoValue,
  Row,
  RowInfo,
  RowMeta,
  RowName,
  RowRight,
  Subtitle,
  Title,
  TitleGroup,
  Unit,
} from "./primitives"

const upcoming = [
  { ticker: "MSFT", when: "Today · After close", est: "3.12" },
  { ticker: "GOOGL", when: "Jan 28 · After close", est: "2.09" },
  { ticker: "META", when: "Jan 29 · After close", est: "6.72" },
]

const surprises = [
  { ticker: "AAPL", surprise: "+4.2%", beat: true },
  { ticker: "AMZN", surprise: "+11.8%", beat: true },
  { ticker: "TSLA", surprise: "-6.1%", beat: false },
]

const CountRow = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
`

const SurpriseWrap = styled.div`
  margin-top: 1.25rem;
  display: flex;
  gap: 0.625rem;
`

const SurpriseChip = styled.div<{ $beat: boolean }>`
  flex: 1;
  border-radius: 1rem;
  padding: 0.75rem;
  text-align: center;
  background: ${(p) =>
    p.$beat ? "var(--color-optimal-muted)" : "var(--color-alert-muted)"};
`

const ChipTicker = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: var(--color-muted-foreground);
`

const ChipValue = styled.p<{ $beat: boolean }>`
  margin: 0.25rem 0 0;
  font-family: var(--font-mono);
  font-size: 1rem;
  font-weight: 600;
  color: ${(p) =>
    p.$beat ? "var(--color-optimal-foreground)" : "var(--color-alert)"};
`

export function EarningsCalendarCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Earnings this week</Title>
          <Subtitle>Consensus EPS estimates</Subtitle>
        </TitleGroup>
        <Badge tone="caution">3 reports</Badge>
      </CardHeader>

      <List>
        {upcoming.map((e) => (
          <Row key={e.ticker}>
            <RowInfo>
              <RowName>{e.ticker}</RowName>
              <RowMeta>{e.when}</RowMeta>
            </RowInfo>
            <RowRight>
              <div style={{ textAlign: "right" }}>
                <RowMeta>Est. EPS</RowMeta>
                <MonoValue>${e.est}</MonoValue>
              </div>
            </RowRight>
          </Row>
        ))}
      </List>
    </Card>
  )
}

export function EarningsSurpriseCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>EPS surprise</Title>
          <Subtitle>Latest reported vs consensus</Subtitle>
        </TitleGroup>
      </CardHeader>

      <CountRow>
        <BigValue>82%</BigValue>
        <Unit>beat rate this season</Unit>
      </CountRow>

      <SurpriseWrap>
        {surprises.map((s) => (
          <SurpriseChip key={s.ticker} $beat={s.beat}>
            <ChipTicker>{s.ticker}</ChipTicker>
            <ChipValue $beat={s.beat}>{s.surprise}</ChipValue>
          </SurpriseChip>
        ))}
      </SurpriseWrap>
    </Card>
  )
}

export default function EarningsCards() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <EarningsCalendarCard />
      <EarningsSurpriseCard />
    </div>
  )
}
